import client from './client';
/**
 * 브라우저 통계
 */
export const browserStatistics = (param) =>
  client.get(`/api/report/browser`, param);

/**
 * 브라우저 통계 그래프
 */
export const browserStatisticsGraph = (param) =>
  client.get(`/api/report/browser/graph`, { params: param });
